import { combineReducers, configureStore } from '@reduxjs/toolkit';
import callReducer from './call.reducer';
import userReducer from './user.reducer';
import chatReducer from './chat.reducer';
import generalReducer from './general.store';
import permissionsReducer from './permissions.reducer';
import configsReducer from './configs.reducer';

function createStore() {
  return configureStore({
    reducer: combineReducers({
      callReducer,
      userReducer,
      chatReducer,
      generalReducer,
      permissionsReducer,
      configsReducer,
    }),
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: {
          ignoredActions: [
            'callReducer/actionSetCallConnection',
            'chat.reducer/actionAddNewChatMessage',
            'call.reducer/actionSetCallConnection',
            'general.reducer/actionShowAlert',
          ],
          ignoredPaths: ['callReducer.activeCall.connection', 'chatReducer.chats', 'generalReducer.alerts'],
        },
      }),
  });
}

if ((module as any).hot) (module as any).hot.accept();

const globalStore = global as typeof global & { __coreStore?: ReturnType<typeof createStore> };
export const coreStore: ReturnType<typeof createStore> = globalStore.__coreStore || (globalStore.__coreStore = createStore());
